import {
  AttachMoney,
  CalendarToday,
  Cancel,
  CheckCircle,
  Event,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Chip,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { QRCodeSVG } from "qrcode.react";
import { useEffect, useState } from "react";
import CurrencyInput from "react-currency-input-field";
import { getUserInfo } from "../../services/auth.service";
import {
  createCommmission,
  deleteCommission,
  getAllCommissions,
  updateCommission,
} from "../../services/commissions.service";
import { getAllEvents } from "../../services/event.service";
import { getUserOnly } from "../../services/expositor/subscriptions.service";
import { useConfirm } from "../../ui-components/ConfirmProvider";
import { ModalComponent, useModal } from "../../ui-components/Modal";
import SectionTitle from "../../ui-components/SectionTitle";
import { useToast } from "../../ui-components/ToastProvider";
import { parseDate, parseDateLocale } from "../../utils/parseDate";

export default function Comissions() {
  const { showToast } = useToast();
  const { confirm } = useConfirm();
  const [events, setEvents] = useState([]);
  const [subs, setSubs] = useState([]);
  const [commissions, setCommissions] = useState([]);
  const [com, setCurrentCom] = useState<any>({});
  const [currentEvent, setCurrentEvent] = useState<any>({});
  const [currentSub, setCurrentSub] = useState<any>({});
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));

  const { open, handleClose, handleOpen } = useModal();
  const {
    open: open2,
    handleClose: handleClose2,
    handleOpen: handleOpen2,
  } = useModal();
  const {
    open: pixOpen,
    handleClose: handlePixClose,
    handleOpen: handlePixOpen,
  } = useModal();

  useEffect(() => {
    getAllEvents().then((x) => {
      setEvents(x);
    });
  }, []);

  useEffect(() => {
    getUserOnly().then((x) => {
      setSubs(x);
    });
  }, []);

  useEffect(() => {
    getAllCommissions().then((x: any) => {
      setCommissions(x);
    });
  }, []);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const userData: any = Object.fromEntries(formData.entries());
    const st = currentSub?.space_type;
    const pctRaw = currentEvent?.event_data?.[st]?.["percentage_" + st];
    const percentage = Number.isFinite(Number(pctRaw)) ? Number(pctRaw) : 10;
    userData.user_id = +getUserInfo().id;
    userData.subscription_id = +userData.subscription_id;
    const raw = String(userData.amount || "")
      .replace(/[^\d,.,]/g, "")
      .replace(/\./g, "")
      .replace(",", ".");
    const gross = parseFloat(raw) || 0;
    userData.amount = Number((gross * (percentage / 100)).toFixed(2));
    const subFound = subs.find(
      (sub: any) => userData.subscription_id === sub.id
    );
    userData.date = subFound?.start_date;

    createCommmission(userData).then(() => {
      handleClose();
      window.location.reload();
    });
  };

  const handleSubmitEdit = (e: any) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const userData: any = Object.fromEntries(formData.entries());
    const percentage = currentEvent.event_data
      ? +currentEvent.event_data[currentSub.space_type][
          "percentage_" + currentSub.space_type
        ]
      : 10;
    userData.user_id = +getUserInfo().id;
    userData.subscription_id = +com.subscription_id;
    const raw = String(userData.amount || "")
      .replace(/[^\d,.,]/g, "")
      .replace(/\./g, "")
      .replace(",", ".");
    const gross = parseFloat(raw) || 0;
    userData.amount = Number((gross * (percentage / 100) * 10).toFixed(2));

    updateCommission(userData, com.id).then((x) => {
      showToast("Comissão editada com sucesso!", { severity: "success" });
      handleClose2();
      window.location.reload();
    });
  };

  return (
    <>
      <ModalComponent open={open} handleClose={handleClose} autoHeight>
        <form style={{ gap: "10px" }} onSubmit={handleSubmit}>
          <SectionTitle title="Declarar uma comissão" />
          <Grid>
            <FormControl
              variant="standard"
              sx={{
                width: "100%",
                gap: 4,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <InputLabel id="demo-simple-select-filled-label">
                Selecione o Evento
              </InputLabel>
              <Select
                required
                labelId="subscription_id"
                id="subscription_id"
                name="subscription_id"
                onChange={(e) => {
                  const id = Number((e.target as any).value);
                  const selectedSub = subs.find((x: any) => x.id === id);
                  if (!selectedSub) {
                    setCurrentSub({});
                    setCurrentEvent({});
                    return;
                  }
                  const evt =
                    events.find(
                      (event: any) => selectedSub.event_id === event.id
                    ) || {};
                  setCurrentSub(selectedSub);
                  setCurrentEvent(evt);
                }}
                fullWidth
              >
                {subs &&
                  subs
                    .filter((x) => x.status_id === 1)
                    .map((sub) => {
                      const event = events.find(
                        (event) => sub.event_id === event.id
                      );
                      const start = event?.starts_at
                        ? parseDate(event.starts_at)
                        : "";
                      const end = event?.ends_at
                        ? parseDate(event.ends_at)
                        : "";
                      const label = `${
                        event?.name || "Evento"
                      } - ${start} à ${end}`;
                      return (
                        <MenuItem key={sub.id} value={sub.id}>
                          {label}
                        </MenuItem>
                      );
                    })}
              </Select>
            </FormControl>

            <Typography sx={{ marginTop: "20px", fontWeight: 500 }}>
              Valor total da sua renda bruta:{" "}
            </Typography>

            <CurrencyInput
              id="amount"
              name="amount"
              prefix="R$"
              placeholder="Valor total da sua renda bruta"
              defaultValue={0}
              decimalsLimit={2}
              style={{
                background: "transparent",
                outline: "none",
                borderBottom: `2px solid ${theme.palette.divider}`,
                color: theme.palette.text.primary,
                fontSize: "1rem",
                fontWeight: 600,
                width: "100%",
                padding: "10px 8px",
              }}
            />
            <Typography
              sx={{
                marginTop: "20px",
                fontWeight: 500,
                marginBottom: "20px",
                color: theme.palette.text.secondary,
              }}
            >
              {(() => {
                const st = currentSub?.space_type;
                const pct =
                  currentEvent?.event_data?.[st]?.["percentage_" + st];
                const val = typeof pct === "number" ? pct : Number(pct);
                const finalPct = Number.isFinite(val) ? val : 10;
                return `Observação: Nossa comissão é de ${finalPct}%`;
              })()}
            </Typography>

            <Button
              onClick={handleClose}
              variant="outlined"
              sx={{ mr: "10px" }}
            >
              Cancelar
            </Button>
            <Button variant="contained" type="submit">
              Criar Comissão
            </Button>
          </Grid>
        </form>
      </ModalComponent>

      <ModalComponent
        open={pixOpen}
        handleClose={handlePixClose}
        maxWidth={isXs ? 320 : 420}
        sx={{ width: isXs ? 320 : 420 }}
        autoHeight
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            p: 1,
            gap: 1,
          }}
        >
          <img
            style={{ marginBottom: "8px", height: 64, width: "auto" }}
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Logo%E2%80%94pix_powered_by_Banco_Central_%28Brazil%2C_2020%29.svg/2560px-Logo%E2%80%94pix_powered_by_Banco_Central_%28Brazil%2C_2020%29.svg.png"
            alt=""
          />
          <QRCodeSVG value={com?.pix_code || ""} size={isXs ? 280 : 320} />
        </Box>
      </ModalComponent>

      <ModalComponent open={open2} handleClose={handleClose2} autoHeight>
        <form style={{ gap: "16px" }} onSubmit={handleSubmitEdit}>
          <SectionTitle title="Editar uma comissão" />
          <Grid>
            <Typography sx={{ marginTop: "20px", fontWeight: 500 }}>
              Valor total da sua renda bruta:{" "}
            </Typography>

            <CurrencyInput
              id="amount"
              name="amount"
              prefix="R$"
              placeholder="Valor total da sua renda bruta"
              defaultValue={0}
              decimalsLimit={2}
              style={{
                background: "transparent",
                outline: "none",
                borderBottom: `2px solid ${theme.palette.divider}`,
                color: theme.palette.text.primary,
                fontSize: "1rem",
                fontWeight: 600,
                width: "100%",
                padding: "10px 8px",
              }}
            />
            <Typography
              sx={{
                marginTop: "20px",
                fontWeight: 500,
                marginBottom: "20px",
                color: theme.palette.text.secondary,
              }}
            >
              Observação: Nossa comissão é de 10%
            </Typography>

            <TextField
              required
              id="firstName"
              name="date"
              label="Dia do evento que voce deseja pagar"
              fullWidth
              type={"date"}
              defaultValue="2022-01-01"
              sx={{ my: 2 }}
              variant={"standard"}
            />
            <Button
              onClick={handleClose}
              variant="outlined"
              sx={{ mr: "10px" }}
            >
              Cancelar
            </Button>
            <Button variant="contained" type="submit">
              Editar Comissão
            </Button>
          </Grid>
        </form>
      </ModalComponent>

      <Grid
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <SectionTitle title="Suas Comissões" />
        <Button
          onClick={handleOpen}
          variant="contained"
          sx={{ textTransform: "none" }}
        >
          Declarar Comissão
        </Button>
      </Grid>
      <Grid container spacing={2}>
        {commissions &&
          commissions.map((commission) => (
            <Grid item xs={12} md={6} key={commission.id}>
              <Paper
                sx={{
                  p: 2,
                  borderRadius: 2,
                  border: `1px solid ${theme.palette.divider}`,
                  boxShadow: "0 2px 10px rgba(36,50,77,0.08)",
                  position: "relative",
                  minHeight: 160,
                }}
              >
                <Box sx={{ position: "absolute", top: 12, right: 12 }}>
                  <Chip
                    label={commission.is_paid ? "Pago" : "Pendente"}
                    color={commission.is_paid ? "success" : "warning"}
                    size="small"
                    icon={commission.is_paid ? <CheckCircle /> : <Cancel />}
                    sx={{ fontWeight: 600 }}
                  />
                </Box>

                <Grid container spacing={1} alignItems="center">
                  <Grid item xs={12}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        color: theme.palette.text.primary,
                      }}
                    >
                      Evento: Praceria
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        color: theme.palette.text.secondary,
                      }}
                    >
                      <CalendarToday fontSize="small" />
                      <Typography variant="body2">
                        Data: {parseDateLocale(commission.date)}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        color: theme.palette.text.secondary,
                      }}
                    >
                      <Event fontSize="small" />
                      <Typography variant="body2">
                        Confirmado pelo evento:{" "}
                        {commission.is_paid ? "Sim" : "Não"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <AttachMoney sx={{ color: theme.palette.success.main }} />
                      <Typography
                        variant="h6"
                        sx={{
                          color: theme.palette.success.main,
                          fontWeight: 700,
                        }}
                      >
                        Valor: R${commission.amount}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>

                <Divider sx={{ my: 2 }} />

                <Grid container spacing={1}>
                  <Grid item xs={12} sm="auto">
                    <Button
                      onClick={() => {
                        setCurrentCom(commission);
                        handlePixOpen();
                      }}
                      variant="contained"
                      sx={{ textTransform: "none" }}
                    >
                      Pagar Pix
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm="auto">
                    <Button
                      variant="outlined"
                      sx={{ textTransform: "none" }}
                      onClick={() => {
                        setCurrentCom(commission);
                        handleOpen2();
                      }}
                    >
                      Alterar dados
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm="auto">
                    <Button
                      variant="text"
                      color="error"
                      sx={{ textTransform: "none" }}
                      onClick={async () => {
                        const ok = await confirm({
                          title: "Apagar comissão",
                          description:
                            "Você realmente deseja apagar essa comissão? Essa ação pode ser irreversível!",
                          confirmText: "Apagar",
                          cancelText: "Cancelar",
                        });
                        if (ok) {
                          deleteCommission(commission.id).then(() => {
                            showToast("Comissão apagada com sucesso!", {
                              severity: "success",
                            });
                            window.location.reload();
                          });
                        }
                      }}
                    >
                      Apagar Comissão
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          ))}
      </Grid>
    </>
  );
}
